import _ from "lodash";

import { dateToString } from "../utils/date/date";

export class AccountingPlanEntity {
    constructor(props) {
        this.props = props;
    }

    getSourcesContractedByModule({ moduleName, type = "object" }) {
        const module = this.props.modules.find((m) => m.name === moduleName);

        if (!module || !_.get(module, "contracted")) {
            if (type === "object") return {};
            else return [];
        }

        if (type === "object") {
            return module.sources.reduce((acc, source) => {
                acc[source] = true;
                return acc;
            }, {});
        } else {
            return module.sources;
        }
    }

    getContractsInSource({ source, modules, features }) {
        const contract = {};

        if (_.get(modules, "length"))
            for (const module of modules) {
                const moduleContracted = this.isContractedModule({
                    source,
                    value: module
                });

                contract[module] = moduleContracted;
            }

        if (_.get(features, "length"))
            for (const feature of features) {
                const featureContracted = this.isContractedFeature({
                    value: feature
                });

                contract[feature] = featureContracted;
            }

        return contract;
    }

    isContractedFeature({ value } = {}) {
        const feature = this.props.features.find((f) => f.name === value);

        return _.get(feature, "contracted") || false;
    }

    isContractedModules({ values }) {
        const isContracteds = {};
        const modules = _.filter(this.props.modules, (p) =>
            values
                .map((v) =>
                    v.sources.some((s) => p.sources.includes(s))
                        ? v.name
                        : false
                )
                .includes(p.name)
        );

        for (let module of modules) {
            if (!isContracteds[module.name]) isContracteds[module.name] = true;
        }

        return Object.values(isContracteds).length ? isContracteds : false;
    }

    isContractedModule({ value, source } = {}) {
        const module = this.props.modules.find(
            (m) => m.name === value && m.sources.includes(source)
        );

        return _.get(module, "contracted") || false;
    }

    isContractedModuleByValue({ value } = {}) {
        const module = this.props.modules.find((m) => m.name === value);

        return _.get(module, "contracted");
    }

    hireFeature({ value }) {
        const featureIndex = this.props.features.findIndex(
            (f) => f.name === value
        );

        this.props.features[featureIndex].contracted = true;
    }

    hireModule({ label, value, source } = {}) {
        let moduleIndex = this.props.modules.findIndex((m) => m.name === value);

        if (moduleIndex === -1) {
            const length = this.props.modules.push({
                label,
                name: value,
                contracted: false,
                sources: []
            });

            moduleIndex = length - 1;
        }

        if (!this.props.modules[moduleIndex].sources.includes(source)) {
            this.props.modules[moduleIndex].sources.push(source);
        }

        if (this.props.modules[moduleIndex].sources.length > 0) {
            this.props.modules[moduleIndex].contracted = true;
        }
    }

    unhireFeature({ value }) {
        const featureIndex = this.props.features.findIndex(
            (f) => f.name === value
        );

        if (featureIndex < 0) return;

        this.props.features[featureIndex].contracted = false;
    }

    unhireModule({ value, source } = {}) {
        const moduleIndex = this.props.modules.findIndex(
            (m) => m.name === value
        );

        if (this.props.modules[moduleIndex].sources.includes(source)) {
            const sourceIndex = this.props.modules[
                moduleIndex
            ].sources.findIndex((s) => s === source);
            this.props.modules[moduleIndex].sources.splice(sourceIndex, 1);
        }

        if (!this.props.modules[moduleIndex].sources.length) {
            this.props.modules[moduleIndex].contracted = false;
        }
    }

    toggleFeatureContract({ value } = {}) {
        if (this.isContractedFeature({ value })) {
            this.unhireFeature({ value });
        } else {
            this.hireFeature({ value });
        }
    }

    toggleModuleContract({ label, value, source } = {}) {
        if (this.isContractedModule({ value, source })) {
            this.unhireModule({ value, source });
        } else {
            this.hireModule({ label, value, source });
        }
    }

    formatDate() {
        const dateFormatted = dateToString(
            this.props.updatedAt || this.props.createdAt,
            "dd MMM yyyy"
        );
        this.props.dateFormatted = dateFormatted;
    }

    formatStatus() {
        if (this.props.visible) {
            this.props.statusLabel = "Visível";
        } else {
            this.props.statusLabel = "Oculto";
        }
    }

    setUpdateAtFilter() {
        if (this.props.updatedAt)
            this.props.updatedAtFilter = this.props.updatedAt;
        else this.props.updatedAtFilter = new Date("2010-01-01");
    }

    setCreatedAt() {
        this.props.createdAt = new Date();
    }

    isDisabledToRemove() {
        return this.props.totalInUse > 0;
    }

    setTooltipDisabled() {
        this.props.tooltipDisabled =
            this.props.totalInUse > 0
                ? "Não é possível excluir esse plano, existem assinaturas vinculadas a ele"
                : "";
    }
}
